import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getData } from '../fetchers';

export const useGetAvailableSlotsQuery = (params) =>
  useQuery({
    queryKey: ['available-slots', params?.params, params?.queryParams],
    queryFn: () => getData('availability/:courtId', params?.params, params?.queryParams),
    select: (data) => data?.data,
    retry: 1,
    enabled: !!params?.params?.courtId,
    placeholderData: keepPreviousData,
  });

export const useGetUnavailableDaysQuery = (params) =>
  useQuery({
    queryKey: ['unavailable-days', params?.params],
    queryFn: () => getData('availability/unavailable-days/:courtId', params?.params),
    select: (data) => data?.data,
    retry: 1,
  });
